export const getModeDefaultTopNavBarStyle = (baseTheme, palette) => {
    return {
        root: {
            background: '#007584',
        },
    };
};
